export default "__VITE_ASSET__BgyJ3Kc5__"